import { useTranslation } from "react-i18next"

import { BookOpen } from "@/components/icons"
import { buttonVariants } from "@/components/ui/button-variants"
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarSub,
  MenubarSubContent,
  MenubarSubTrigger,
  MenubarTrigger,
} from "@/components/ui/menubar"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

const SAMPLE_PERSONAL_PROMPTS = [
  { id: "1", title: "Summarize document" },
  { id: "2", title: "Extract key points" },
]

const SAMPLE_COMPANY_PROMPTS = [
  { id: "3", title: "Generate meeting notes" },
  { id: "4", title: "Create project plan" },
]

export function DemoPromptsMenu() {
  const { t } = useTranslation()

  return (
    <Menubar className="border-none bg-transparent p-0 shadow-none">
      <MenubarMenu>
        <Tooltip>
          <TooltipTrigger asChild>
            <MenubarTrigger
              className={cn(
                buttonVariants({
                  size: "icon",
                  variant: "icon",
                }),
                "!size-7 cursor-pointer !p-0 !px-0 !py-0"
              )}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
              }}
            >
              <BookOpen className="size-5" />
            </MenubarTrigger>
          </TooltipTrigger>
          <TooltipContent className="max-w-[250px]" side="bottom" sideOffset={5}>
            <p>{t("prompts.title")}</p>
          </TooltipContent>
        </Tooltip>

        <MenubarContent align="start" className="z-50" side="top">
          <MenubarSub>
            <MenubarSubTrigger onClick={(e) => e.stopPropagation()}>
              {t("prompts.personal")}
            </MenubarSubTrigger>
            <MenubarSubContent className="max-h-[500px] max-w-[130px] overflow-y-auto sm:max-w-[250px]">
              {SAMPLE_PERSONAL_PROMPTS.map((prompt) => (
                <MenubarItem key={prompt.id} className="max-w-full cursor-pointer">
                  <span className="truncate">{prompt.title}</span>
                </MenubarItem>
              ))}
            </MenubarSubContent>
          </MenubarSub>

          <MenubarSub>
            <MenubarSubTrigger onClick={(e) => e.stopPropagation()}>
              {t("prompts.company")}
            </MenubarSubTrigger>
            <MenubarSubContent className="max-h-[500px] max-w-[130px] overflow-y-auto sm:max-w-[250px]">
              {SAMPLE_COMPANY_PROMPTS.map((prompt) => (
                <MenubarItem key={prompt.id} className="max-w-full cursor-pointer">
                  <span className="truncate">{prompt.title}</span>
                </MenubarItem>
              ))}
            </MenubarSubContent>
          </MenubarSub>

          <MenubarSeparator />
          <MenubarItem disabled>{t("prompts.manage")}</MenubarItem>
        </MenubarContent>
      </MenubarMenu>
    </Menubar>
  )
}
